import {Component, inject, input, InputSignal, model, ModelSignal, Signal, signal, viewChild, ViewEncapsulation, WritableSignal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DxNumberBoxModule, DxPopupModule} from 'devextreme-angular';
import {SharedModule} from '../../../../../shared/shared.module';
import {JourSemaine} from '../../../../../core/constants';
import {RepasDTO} from '../../../../../core/dtos/repas-dto';
import {DecoupageRepasDTO} from '../../../../../core/dtos/decoupagerepas-dto';
import {ContratMenuConviveRepasDTO} from '../../../../../core/dtos/contratmenuconviverepas-dto';
import {ContratMenuConviveDecoupageDTO} from '../../../../../core/dtos/contratmenuconvivedecoupage-dto';
import {ContratMenuConviveDecoupage__PlcDTO} from '../../../../../core/dtos/contratmenuconvivedecoupage__plc-dto';
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';
import {UtilsService} from '../../../../../core/utils/utils.service';
import {TreeListComponent} from '../../../../../shared/ui/tree-list/tree-list.component';
import {find as _find} from 'lodash';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'yo-dialog-update-taux-prise',
  templateUrl: './dialog-update-taux-prise.component.html',
  styleUrls: ['./dialog-update-taux-prise.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, DxPopupModule, DxNumberBoxModule, SharedModule],
  encapsulation: ViewEncapsulation.None
})
export class DialogUpdateTauxPriseComponent {

  visible: ModelSignal<boolean> = model<boolean>(false);
  joursSemaine: InputSignal<JourSemaine[]> = input<JourSemaine[]>([]);
  repasList: InputSignal<RepasDTO[]> = input<RepasDTO[]>([]);
  decoupageRepasList: InputSignal<DecoupageRepasDTO[]> = input<DecoupageRepasDTO[]>([]);
  platList: InputSignal<SelectItem[]> = input<SelectItem[]>([]);
  rows: InputSignal<ContratMenuConviveRepasDTO[]> = input<ContratMenuConviveRepasDTO[]>([]);
  cells: InputSignal<ContratMenuConviveDecoupageDTO[]> = input<ContratMenuConviveDecoupageDTO[]>([]);
  cmcdPlcList: InputSignal<ContratMenuConviveDecoupage__PlcDTO[]> = input<ContratMenuConviveDecoupage__PlcDTO[]>([]);

  treeListJours: Signal<TreeListComponent | undefined> = viewChild<TreeListComponent>('treeListJours');
  treeListRepas: Signal<TreeListComponent | undefined> = viewChild<TreeListComponent>('treeListRepas');
  treeListDecoupageRepas: Signal<TreeListComponent | undefined> = viewChild<TreeListComponent>('treeListDecoupageRepas');
  treeListPlat: Signal<TreeListComponent | undefined> = viewChild<TreeListComponent>('treeListPlat');

  readonly ButtonThemeEnum = ButtonThemeEnum;
  #utils = inject(UtilsService);

  selectedJoursSemaine: JourSemaine[] = [];
  selectedRepasList: RepasDTO[] = [];
  selectedDecoupageRepasList: DecoupageRepasDTO[] = [];
  selectedPlatList: number[] = [];
  inputValue: WritableSignal<number | null> = signal<number | null>(null);

  closeDialog(): void {
    this.selectedJoursSemaine = [];
    this.selectedRepasList = [];
    this.selectedDecoupageRepasList = [];
    this.selectedPlatList = [];
    this.inputValue.set(null);
    this.treeListJours()?.clearSelection();
    this.treeListRepas()?.clearSelection();
    this.treeListDecoupageRepas()?.clearSelection();
    this.treeListPlat()?.clearSelection();
    this.visible.set(false);
  }

  save(): void {
    const rowList = this.rows();
    const cellList = this.cells();
    const plcList = this.cmcdPlcList();
    if (this.#utils.isCollectionNullOrEmpty(rowList)) return;
    if (this.inputValue() == null) return;

    for (const jourSemaine of this.selectedJoursSemaine) {
      for (const repas of this.selectedRepasList) {
        const cmcr = _find(rowList, {
          repasId: repas.id,
          idJourSemaine: jourSemaine.value
        }) as ContratMenuConviveRepasDTO;

        if (!this.#utils.isNullOrEmpty(cmcr)) {
          for (const decoupageRepas of this.selectedDecoupageRepasList) {
            const cmcd = _find(cellList, {
              decoupageRepasId: decoupageRepas.id,
              repasId: repas.id,
              contratMenuConviveRepasIdJourSemaine: jourSemaine.value
            });

            if (!this.#utils.isNullOrEmpty(cmcd) && !this.#utils.isCollectionNullOrEmpty(cmcd.contratMenuConvivePlatDTOList)) {
              this.#applyTauxDePrise(cmcd.id, plcList);
            }
          }
        }
      }
    }
    this.closeDialog();
  }

  #applyTauxDePrise(cmcdId: number, plcList: ContratMenuConviveDecoupage__PlcDTO[]): void {
    const taux = this.inputValue();
    for (const cmcdPlc of plcList) {
      if (this.selectedPlatList.includes(cmcdPlc.ordre) && cmcdPlc.idContratMenuConviveDecoupage === cmcdId) {
        cmcdPlc.tauxDePrise = taux;
      }
    }
  }

  protected onChangePlat(ordreList: number[]): void {
    this.selectedPlatList = ordreList;
  }

  protected onChangeDecoupageRepas(decoupageRepasList: DecoupageRepasDTO[]): void {
    this.selectedDecoupageRepasList = decoupageRepasList;
  }

  protected onChangeRepas(repasList: RepasDTO[]): void {
    this.selectedRepasList = repasList;
  }

  protected onChangeJoursSemaine(joursSemaine: JourSemaine[]): void {
    this.selectedJoursSemaine = joursSemaine;
  }
}
